<style scoped lang="sass">
.title
  font-weight: 700
  margin-bottom: 0.5rem
</style>
<template>
  <div class="page">
    <div class="padded">
      <div class="title">Contact PinHigh</div>
      <form @submit.prevent="send">
        <div v-if="errors.length">
          <div v-for="error in errors">{{error}}</div>
        </div>
        <div class="input-group">
          <label>MESSAGE</label>
          <textarea v-model="contact.message" placeholder="Your message here..." class="input-control"></textarea>
        </div>
        <input type="submit" class="button positive" :value="sent ? 'Sent!' : (sending ? 'Sending...' : 'Send')" :disabled="!valid || sending">
      </form>
    </div>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'Contact',
  data() {
    return {
      contact: {},
      errors: [],
      sending: false,
      sent: false
    };
  },
  created() {
    this.$store.dispatch('configNavigation', {leftEnabled: true, leftRoute: {name: 'dashboard'}, leftImg: 'icon-back.svg'});
  },
  computed: {
    valid() {
      return this.contact.message && this.contact.message.length;
    }
  },
  methods: {
    send() {
      this.sending = true;
      api.Contact.create({params: {contact: this.contact}})
        .then(() => {
          this.sent = true;
          setTimeout(() => this.$router.push({name: 'dashboard'}), 2000);
        })
        .catch(({response: {data: {errors}}}) => {
          this.errors = errors;
          this.sending = false;
        });
    }
  }
};
</script>
